import { Injectable } from '@angular/core';
import { PoolShellStatusEnum } from 'src/app/shared/enumerators/pool-shell-status.enum';
import { ProductStatusEnum } from 'src/app/shared/enumerators/product-status.enum';

@Injectable({
  providedIn: 'root',
})
export class ManufacturingOrderStatusService {
  getProdStatus(statusId: ProductStatusEnum): string {
    switch (statusId) {
      case ProductStatusEnum.Pendiente:
        return 'ProdPendiente';
      case ProductStatusEnum.EnProceso:
        return 'ProdEnProceso';
      case ProductStatusEnum.Lista:
        return 'ProdLista';
      case ProductStatusEnum.Modificada:
        return 'ProdModificada';
      default:
        return 'ProdPendiente';
    }
  }

  getPoolStatus(status: PoolShellStatusEnum): string {
    switch (status) {
      case PoolShellStatusEnum.Programada:
        return 'PoolProgramada';
      case PoolShellStatusEnum.Lista:
        return 'ProdLista';
      case PoolShellStatusEnum.Modificada:
        return 'ProdModificada';
      case PoolShellStatusEnum.Pendiente:
      default:
        return 'ProdPendiente';
    }
  }
}
